export default "__VITE_ASSET__kbXDE5DO__"